'use client'

import {
  PricingRuleModel,
  isFactGroup,
  CatalogModel,
} from '@marketplace-web/escrow-pricing/escrow-pricing-data'
import { CountryModel } from '@marketplace-web/country/country-data'

import FactGroupSection from '../FactGroupSection'

type Props = {
  priceRule: PricingRuleModel
  countries?: Array<CountryModel> | null
  catalogs?: Array<CatalogModel>
}

const FactGroupList = ({ priceRule, countries, catalogs }: Props) => {
  const factGroupList = priceRule.conditionTree.all.items.filter(isFactGroup)

  return factGroupList.map(factGroup => (
    <div data-testid="available-discount__fact-group-item" key={factGroup.id}>
      <FactGroupSection
        catalogs={catalogs}
        countries={countries}
        factGroup={factGroup}
        currencyCode={priceRule.currency}
      />
    </div>
  ))
}

export default FactGroupList
